import styles from "../styles/Layout.module.css";
import Header from './header';
import Footer from './footer';

const Layout = ({children, currentScreen, showInitialScreen, showAppointmentScreen}) => {
    return (
        <div className="min-h-screen flex flex-col font-sans">
            <Header currentScreen={currentScreen} showInitialScreen={showInitialScreen} showAppointmentScreen={showAppointmentScreen} />
            <div className={styles.content}>{children}</div>
            <Footer/>
        </div>
    );
}

export default Layout;
